import { useQuery } from '@tanstack/react-query'
import { fetchCities } from '@/lib/api'

export const useCities = (stateId: string | undefined) => {
  return useQuery({
    queryKey: ['cities', stateId],
    queryFn: () => fetchCities(stateId!),
    enabled: !!stateId,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false
  })
}
